// SEO Configuration for AssetFlows
// Conversion-focused titles, descriptions, and keywords for every public-facing page.

const seoConfig = {
  home: {
    title: 'AssetFlows – Best Asset Management Software for Smarter Tracking & Control',
    description:
      'Manage your assets with confidence using AssetFlows—real-time tracking, automated maintenance, and powerful reporting designed to reduce loss and improve visibility.',
    keywords:
      'best asset management software, asset tracking software, enterprise asset management, IT asset management, fixed asset management, asset lifecycle management, AssetFlows',
    ogTitle: 'AssetFlows – Best Asset Management Software',
    ogDescription:
      'Reduce loss, improve visibility, and simplify asset management with AssetFlows.',
  },

  features: {
    title: 'AssetFlows Features – Real-Time Asset Tracking, Maintenance & Reporting',
    description:
      'See how AssetFlows helps teams streamline asset tracking, automate maintenance, and gain actionable insights with easy-to-use tools.',
    keywords:
      'asset tracking features, barcode asset tracking, asset maintenance software, asset management dashboard, role-based asset management, asset analytics, asset reporting software',
    ogTitle: 'AssetFlows Features – Built to Improve Visibility and Control',
    ogDescription:
      'Track assets in real time, automate maintenance, and simplify operations with AssetFlows.',
  },

  pricing: {
    title: 'Affordable Asset Management Software Pricing | AssetFlows',
    description:
      'Compare flexible AssetFlows pricing plans for startups, growing teams, and enterprises. Start free and scale with confidence.',
    keywords:
      'asset management pricing, asset management software cost, affordable asset management, asset management subscription plans, asset management free trial',
    ogTitle: 'AssetFlows Pricing – Plans That Scale With Your Business',
    ogDescription:
      'Choose a flexible plan that fits your business and unlocks better asset control.',
  },

  whyAssetFlows: {
    title: 'Why Choose AssetFlows? – Smarter Asset Management for Better Results',
    description:
      'Discover why businesses choose AssetFlows to reduce asset loss, cut manual work, and gain full visibility across every asset.',
    keywords:
      'why choose AssetFlows, benefits of asset management software, asset management ROI, reduce asset loss, best asset management software',
    ogTitle: 'Why AssetFlows? – Smarter Asset Management, Proven Results',
    ogDescription:
      'Cut manual effort, improve accountability, and gain full asset visibility with AssetFlows.',
  },

  contact: {
    title: 'Contact AssetFlows – Book a Demo or Get Sales Support',
    description:
      'Talk to the AssetFlows team for product demos, pricing questions, technical support, and partnership opportunities.',
    keywords:
      'contact AssetFlows, asset management demo request, asset management support, asset management consultation, book a demo',
    ogTitle: 'Contact AssetFlows – Talk to Our Team',
    ogDescription:
      'Book a free demo, get pricing details, or reach our support team.',
  },

  blogs: {
    title: 'AssetFlows Blog – Latest Insights on Asset Management',
    description:
      'Explore the latest articles on asset tracking, maintenance, compliance, and smarter asset operations from AssetFlows.',
    keywords:
      'asset management blog, latest asset management insights, asset tracking trends, maintenance blog, business asset management',
    ogTitle: 'AssetFlows Blog – Latest Asset Management Insights',
    ogDescription:
      'Read practical articles that help teams improve visibility, control, and performance across their assets.',
  },

  blogDetail: {
    title: '{blogTitle} | AssetFlows Blog',
    description: '{blogExcerpt} Read the full article on AssetFlows for practical insights and expert guidance.',
    keywords:
      'asset management blog, {blogTitle}, AssetFlows, asset tracking, inventory management, business asset strategy',
    ogTitle: '{blogTitle} | AssetFlows Blog',
    ogDescription: '{blogExcerpt} Read the full article on AssetFlows for practical insights and expert guidance.',
  },

  industryInfo: {
    title: 'Asset Management for {industry} Industry | AssetFlows',
    description:
      'See how AssetFlows helps {industry} businesses improve asset visibility, reduce downtime, and manage operations more efficiently.',
    keywords:
      '{industry} asset management, asset tracking for {industry}, equipment management {industry}, inventory software {industry}',
    ogTitle: 'AssetFlows for {industry} – Industry-Specific Asset Management',
    ogDescription:
      'Purpose-built asset management features for the {industry} industry. Improve control and reduce operational risk.',
  },

  login: {
    title: 'Login to AssetFlows – Manage Assets from Your Dashboard',
    description:
      'Sign in to your AssetFlows account to manage assets, track maintenance, and monitor your portfolio in real time.',
    keywords:
      'AssetFlows login, asset management login, sign in asset management software, asset tracking login',
    ogTitle: 'Login – AssetFlows Asset Management',
    ogDescription: 'Access your AssetFlows dashboard to manage assets and maintenance in one place.',
  },

  signup: {
    title: 'Sign Up Free – Start Managing Assets Smarter with AssetFlows',
    description:
      'Create your free AssetFlows account and start tracking, managing, and optimizing business assets in minutes.',
    keywords:
      'AssetFlows signup, free asset management software, register asset management, create asset management account, start asset tracking free',
    ogTitle: 'Sign Up Free – AssetFlows Asset Management',
    ogDescription:
      'Get started with AssetFlows for free and improve asset control right away.',
  },

  forgotPassword: {
    title: 'Forgot Password – Recover Your AssetFlows Account',
    description:
      'Reset your AssetFlows password quickly and securely to regain access to your asset management dashboard.',
    keywords: 'AssetFlows forgot password, reset password, account recovery, AssetFlows login help',
    ogTitle: 'Reset Your Password – AssetFlows',
    ogDescription: 'Recover access to your AssetFlows account quickly and securely.',
  },

  barcodeDetails: {
    title: 'Asset Barcode Lookup | AssetFlows Quick Asset Search',
    description:
      'Scan or enter an AssetFlows barcode to instantly view asset details, maintenance history, location, and status.',
    keywords:
      'asset barcode lookup, scan asset barcode, asset tracking barcode, barcode asset management, quick asset lookup',
    ogTitle: 'Asset Barcode Details – AssetFlows',
    ogDescription:
      'Instantly view asset details, history, and status by scanning or entering an AssetFlows barcode.',
  },
};

export default seoConfig;
